import PropTypes from 'prop-types'
import getCss from '../get-css'
import {spacesOutsideParentheses} from '../utils/regex'

export const propTypes = {
  borderBottomLeftRadius: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  borderBottomRightRadius: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  borderRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  borderTopLeftRadius: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  borderTopRightRadius: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
}

export const propAliases = {
  borderRadius: [
    'borderBottomLeftRadius',
    'borderBottomRightRadius',
    'borderTopLeftRadius',
    'borderTopRightRadius'
  ]
}

export const propValidators = {}

if (process.env.NODE_ENV !== 'production') {
  propValidators.borderRadius = value => {
    if (spacesOutsideParentheses.test(value)) {
      return `multiple values (“${value}”) aren՚t supported with “borderRadius”. Use “borderBottomLeftRadius”, “borderBottomRightRadius” “borderTopLeftRadius” and “borderTopRightRadius” instead.`
    }
  }
}

const borderTopLeftRadius = {
  className: 'btlr',
  cssName: 'border-top-left-radius',
  jsName: 'borderTopLeftRadius'
}
const borderTopRightRadius = {
  className: 'btrr',
  cssName: 'border-top-right-radius',
  jsName: 'borderTopRightRadius'
}
const borderBottomLeftRadius = {
  className: 'bblr',
  cssName: 'border-bottom-left-radius',
  jsName: 'borderBottomLeftRadius'
}
const borderBottomRightRadius = {
  className: 'bbrr',
  cssName: 'border-bottom-right-radius',
  jsName: 'borderBottomRightRadius'
}

export const propEnhancers = {
  borderBottomLeftRadius: value => getCss(borderBottomLeftRadius, value),
  borderBottomRightRadius: value => getCss(borderBottomRightRadius, value),
  borderTopLeftRadius: value => getCss(borderTopLeftRadius, value),
  borderTopRightRadius: value => getCss(borderTopRightRadius, value)
}
